export default [
  {
    title: 'dashboard.mainVerticalMenu.home',
    icon: 'HomeIcon',
    route: 'dashboard',
    resource: 'dashboard',
    action: 'read',
  },
]
